import React from "react";
import { withPreloadedJSON } from "@wss/hypernova";
import { createRoot } from "@wss/react";
import { initSentry } from "@wss/error-tracking/sentry";
import {
  ErrorBoundary,
  logErrorBoundaryToSentry,
  PageFallback,
} from "@wss/error-tracking/error-boundary";
import App from "~/App";
import { Header } from "~/common/Header/index.client";
import { Footer } from "~/common/Footer/index.client";
import ProductDetails from ".";

import "~/fonts/fontello/css/fontello-top.less";
import "~/less/_critical/include.less";
import "~/less/_critical/product.less";
import "./VirtualGrouping/VirtualGroupingStyles.less";
import withFeatureFlags from "~/common/hocs/withFeatureFlags";
import PageResult from "~/common/types/PageResult";
import { sendGtmEvent } from "~/analytics/definitions";

/** Enable hot reloading */
module.hot?.accept();

initSentry("Product Details Page");

function ProductDetailsPage(props: PageResult): JSX.Element {
  return (
    <ErrorBoundary
      fallback={<PageFallback />}
      onError={logErrorBoundaryToSentry}
    >
      <ProductDetails {...props} />
    </ErrorBoundary>
  );
}

const ProductDetailsWithData = withPreloadedJSON(
  ProductDetailsPage,
  "ProductDetails",
);

const root = createRoot(document.querySelector("#root"));

root.render(
  <App>
    <Header />
    <ProductDetailsWithData />
    <Footer />
  </App>,
);

window.addEventListener("beforeprint", () => {
  sendGtmEvent({
    event: "ga4_event",
    eventName: "pdf_print",
  });
});
